import React from "react";

const TextPill = ({ children, style, ...otherProps}) => {
    return (
        <span style={Object.assign({
            borderRadius: "50px",
            background: "var(--primary)",
            color: "white",
            padding: "0.2em 1em",
            fontSize: "0.65em"
        }, style)} {...otherProps}>
            {children}
        </span>
    )
}

export default TextPill;